import axios from "./axios";

const prefix = "/v2/sales";

export function getCompanyLocationSales(
  COMPANY_ID: string,
  SHOP_IDS: string[],
  targetDate: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        SHOP_IDS: JSON.stringify(SHOP_IDS),
        targetDate,
      });
      const response = await axios.get(
        `${prefix}/getCompanyLocationSales?${searchParams.toString()}`
      );
      resolve(response);
    } catch (e) {
      console.log(`${prefix} getCompanyLocationSales error: `, e);
      reject(e);
    }
  });
}

export function getShopLocationSales(
  SHOP_ID: string,
  startDate: string,
  endDate: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        SHOP_ID,
        startDate,
        endDate,
      });

      const response = await axios.get(
        `${prefix}/getShopLocationSales?${searchParams.toString()}`
      );

      resolve(response);
    } catch (e) {
      console.log(`${prefix} getShopLocationSales error: `, e);
      reject(e);
    }
  });
}

export function getCompanyBldPops(
  COMPANY_ID: string,
  lat: string,
  lng: string,
  radius: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        lat,
        lng,
        radius,
      });

      const response = await axios.get(
        `${prefix}/getCompanyBldPops?${searchParams.toString()}`
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getCompanyBldPopsPolygon(COMPANY_ID: string, polygon: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ COMPANY_ID, polygon });
      const response = await axios.post(
        `${prefix}/getCompanyBldPopsPolygon?${searchParams.toString()}`,
        { COMPANY_ID, polygon }
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getShopBldPops(
  SHOP_ID: string,
  lat: string,
  lng: string,
  radius: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        SHOP_ID,
        lat,
        lng,
        radius,
      });

      const response = await axios.get(
        `${prefix}/getShopBldPops?${searchParams.toString()}`
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getShopBldPopsPolygon(SHOP_ID: string, polygon: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ SHOP_ID, polygon });
      const response = await axios.post(
        `${prefix}/getShopBldPopsPolygon?${searchParams.toString()}`,
        { SHOP_ID, polygon }
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getRGC(lat: any, lng: any) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ lat, lng });
      const response = await axios.post(
        `/v2/map/getRGC?${searchParams.toString()}`,
        { lat, lng }
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getCompanyCircleLocationSales(
  COMPANY_ID: any,
  lat: any,
  lng: any,
  radius: any,
  targetDate: any
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        lat,
        lng,
        radius,
        targetDate,
      });

      const response = await axios.post(
        `${prefix}/getCompanyCircleLocationSales?${searchParams.toString()}`,
        { COMPANY_ID, lat, lng, radius, targetDate }
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getShopCircleLocationSales(
  SHOP_ID: any,
  startDate: any,
  endDate: any,
  lat: any,
  lng: any,
  radius: any
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        SHOP_ID,
        startDate,
        endDate,
        lat,
        lng,
        radius,
      });

      const response = await axios.post(
        `${prefix}/getShopCircleLocationSales?${searchParams.toString()}`,
        {
          SHOP_ID,
          startDate,
          endDate,
          lat,
          lng,
          radius,
        }
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getCompanyPolygonLocationSales(
  COMPANY_ID: any,
  targetDate: any,
  polygon: any
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        COMPANY_ID,
        targetDate,
        polygon,
      });

      const response = await axios.post(
        `${prefix}/getCompanyPolygonLocationSales?${searchParams.toString()}`,
        { COMPANY_ID, targetDate, polygon }
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getShopPolygonLocationSales(
  SHOP_ID: any,
  startDate: any,
  endDate: any,
  polygon: any
) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({
        SHOP_ID,
        startDate,
        endDate,
        polygon,
      });

      const response = await axios.post(
        `${prefix}/getShopPolygonLocationSales?${searchParams.toString()}`,
        { SHOP_ID, startDate, endDate, polygon }
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}

export function getShopSalesForLocation(SHOP_ID: string, targetDate: string) {
  return new Promise(async (resolve, reject) => {
    try {
      const searchParams = new URLSearchParams({ SHOP_ID, targetDate });

      const response = await axios.get(
        `${prefix}/getShopSalesForLocation?${searchParams.toString()}`
      );

      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
}
